import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
	AppAdsFilter,
	AppAdsPages,
	AppAdsTypes,
} from '../../components/AppAds';

interface IAdsSlice {
	activeFilter: AppAdsFilter;
	activePage: AppAdsPages;
	activeCarModelFilter: string;
	activeRealtyTypeFilter: string;
	activeClothesTypeFilter: string;
	activeOtherTypeFilter: string;
	itemPageVisible: boolean;
	reportVisible: boolean;
	categorySelectVisible: boolean;
	itemSelectVisible: boolean;
	createVisible: boolean;
	doneVisible: boolean;
	createCategory: AppAdsTypes;
	itemType: AppAdsTypes;
}

const initialState: IAdsSlice = {
	activeFilter: AppAdsFilter.Main,
	activePage: AppAdsPages.Main,
	activeCarModelFilter: '',
	activeRealtyTypeFilter: '',
	activeClothesTypeFilter: '',
	activeOtherTypeFilter: '',
	itemPageVisible: false,
	reportVisible: false,
	categorySelectVisible: false,
	itemSelectVisible: false,
	createVisible: false,
	doneVisible: false,
	createCategory: AppAdsTypes.Realty,
	itemType: AppAdsTypes.Realty,
};

const adsSlice = createSlice({
	name: 'ads',
	initialState,
	reducers: {
		setActiveFilter: (state, action) => {
			state.activeFilter = action.payload;
		},
		setActivePage: (state, action) => {
			state.activePage = action.payload;
		},
		setModelFilter: (
			state,
			action: PayloadAction<{ type: AppAdsTypes; value: string }>,
		) => {
			if (action.payload.type === AppAdsTypes.Vehicle) {
				state.activeCarModelFilter = action.payload.value;
				state.activeRealtyTypeFilter = '';
				state.activeClothesTypeFilter = '';
				state.activeOtherTypeFilter = '';
			}
			if (action.payload.type === AppAdsTypes.Realty) {
				state.activeRealtyTypeFilter = action.payload.value;
				state.activeCarModelFilter = '';
				state.activeClothesTypeFilter = '';
				state.activeOtherTypeFilter = '';
			}
			if (action.payload.type === AppAdsTypes.Clothes) {
				state.activeClothesTypeFilter = action.payload.value;
				state.activeCarModelFilter = '';
				state.activeRealtyTypeFilter = '';
				state.activeOtherTypeFilter = '';
			}
			if (action.payload.type === AppAdsTypes.Other) {
				state.activeOtherTypeFilter = action.payload.value;
				state.activeCarModelFilter = '';
				state.activeRealtyTypeFilter = '';
				state.activeClothesTypeFilter = '';
			}
		},
		setItemPageVisible: (state, action) => {
			state.itemPageVisible = action.payload;
		},
		setReportVisible: (state, action) => {
			state.reportVisible = action.payload;
		},
		setCategorySelectVisible: (state, action) => {
			state.categorySelectVisible = action.payload;
		},
		setItemSelectVisible: (state, action) => {
			state.itemSelectVisible = action.payload;
		},
		setCreateVisible: (state, action) => {
			state.createVisible = action.payload;
		},
		setCreateCategory: (state, action) => {
			state.createCategory = action.payload;
		},
		setDoneVisible: (state, action) => {
			state.doneVisible = action.payload;
		},
		setItemType: (state, action) => {
			state.itemType = action.payload;
		},
		resetSlice: () => ({ ...initialState }),
	},
});

export const {
	setActiveFilter,
	setActivePage,
	setItemPageVisible,
	setReportVisible,
	setCategorySelectVisible,
	setItemSelectVisible,
	setCreateVisible,
	setCreateCategory,
	setDoneVisible,
	setItemType,
	resetSlice,
	setModelFilter,
} = adsSlice.actions;

export default adsSlice.reducer;
